import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {  STATUS , PythonDomain } from "../../../Constants";
import axios from "axios";



// For Extract Data From DB API
// const extractDataFromDBEndpoint = ()=> `${DomainName}/page/search` ; 
const extractDataFromDBEndpoint = ()=> `${PythonDomain}` ; 

export const extractDataFromDBAPI = createAsyncThunk('extractDB/getC', async (args, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;
  try {
    const response = await axios.post(extractDataFromDBEndpoint(args),{
      // database: "egy21DB.csv",
      // searchTerms: args.selectedID,
      // field: "FBID",
      searchTerms : args.selectedID , 
      indexField: "FBID",
      user_id:args.userId, //args.username || "nadeenmohamed" ,
      db_name : args.db_name
    }, {
      
      headers: {
        token: args.token,
        term: "Kane",
      },
      // Add the body here
      
    });
    return response.data?.results ;
  } catch (error) {
    return rejectWithValue(error);
  }
});

// For Default State
const initialState = {
  data : [] , 
  status : STATUS.IDLE
}

const ExtractDataFromDBSlice = createSlice({
  name : "extractDB" , 
  initialState , 
  reducers : {

  } , 
  extraReducers : (builder)=>{
    builder
    // For Store Data 
    .addCase(extractDataFromDBAPI.fulfilled , (state , action)=>{
      state.data = action.payload ; 
      state.status = STATUS.SUCCESS ;
    })
    .addCase(extractDataFromDBAPI.pending , (state )=>{
      state.status = STATUS.LOADDING ;
    })
    .addCase(extractDataFromDBAPI.rejected , (state )=>{
      state.status = STATUS.ERROR ;
    })
  }
})

export default ExtractDataFromDBSlice.reducer ; 

